import BaseScene from './BaseScene'
import { ScorerSpeed, WalkSpeed, BrownianSpeed } from './Constants'
import { delay } from '../helper'
import * as sounds from '../../../constants/Sounds'

export default class HalfTime extends BaseScene {
    constructor(event, pitch) {
        super(pitch);

        let keyPoints = pitch.getKeyPoints(true);

        this.CenterPoint = keyPoints.center;
        this.HomeSubstitutionPoint = keyPoints.substitutionPoint;
        this.AwaySubstitutionPoint = pitch.getKeyPoints(false).substitutionPoint;
    }

    Play(gameSpeed) {
        return new Promise(function(resolve, reject) {

            this.SoundManager.play(sounds.GAME_END);

            this.getPlayersByTeam(true)
                .forEach((player) => player.MoveToWithSpeed(gameSpeed, WalkSpeed, this.HomeSubstitutionPoint));

            this.getPlayersByTeam(false)
                .forEach((player) => player.MoveToWithSpeed(gameSpeed, WalkSpeed, this.AwaySubstitutionPoint));

            delay(180*gameSpeed).then(resolve);

        }.bind(this));
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/HalfTime.js
 **/